import infoSys from 'assets/img/train/summer-institute.png'
import oceanside from 'assets/img/common/oceanside-community-foundation.png'

export const courseSupport = {
  paragraph: 'We are grateful for the support and partnership of',
  logo: [
    {
      src: infoSys,
      alt: 'Info System',
    },
  ],
}
